'use client';

import { PropsWithChildren } from 'react';
import { useWidgetMessages } from '@/hooks/useWidgetMessages';
export const WidgetMessageListener = ({
  children
}: PropsWithChildren) => {
  useWidgetMessages();
  return children;
};